"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUser = exports.UserFormSerializer = exports.userLicenseFormSerializer = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("../../../utils/common");
const userFormPros = {
    email: 'email.value',
    name: 'name.value',
    bio: 'bio.value',
    phone: 'phone.value',
    pro_bono: 'pro_bono.value',
    additional_phone: 'additional_phone.value',
    contact_person: 'contact_person.value',
    address: 'address.value',
    fulladdress: 'full_address.value',
    city: 'city.value',
    state: 'state.value.state_id',
    zipCode: 'zipCode.value',
    hourly_rate: 'hourly_rate.value'
};
const userLicenseFormPros = {
    state: 'state.value.id',
    barNumber: 'license.value'
};
const userLicenseFormSerializer = (userData, omit) => {
    const data = {};
    for (const prop of Object.keys(userLicenseFormPros)) {
        if (omit && prop === omit) {
            continue;
        }
        data[prop] = _.get(userData, userLicenseFormPros[prop]);
    }
    return data;
};
exports.userLicenseFormSerializer = userLicenseFormSerializer;
const UserFormSerializer = (userData, omit) => {
    const data = {};
    for (const prop of Object.keys(userFormPros)) {
        if (omit && prop === omit) {
            continue;
        }
        data[prop] = _.get(userData, userFormPros[prop]);
        if (data[prop] && typeof data[prop] === 'string') {
            data[prop] = data[prop].trim();
        }
    }
    return data;
};
exports.UserFormSerializer = UserFormSerializer;
const mutateUser = (user) => {
    var _a;
    user.ratesCount = user.ratesResult[0].count;
    user.rate = parseFloat(user.ratesResult[0].avg ? user.ratesResult[0].avg.toFixed(1) : 0);
    user.bio = common_1.replaceChars(user.bio);
    user.barNumber = user.barNumber ? parseInt(user.barNumber) : '';
    user.last4Digit = user.stripeTokenId;
    user.userStateBarUrl = user.stateBarUrl;
    user.verifiedDate = user.verifiedDate ? user.verifiedDate : user.updatedAt;
    user.firstBarNum = user.states.length ? user.states[0].bar_number_updated : '';
    user.state = String(user.state && user.address ? user.state : (user.states.length === 1 ? user.states[0].state_id : '-1'));
    user.userStateName = (user.statesAll && user.statesAll.length) ? (_a = (user.statesAll.find((s) => user.state == s.state_id))) === null || _a === void 0 ? void 0 : _a.state_name : '';
    user.acceptedCasesCount = parseInt(user.acceptedcasescount) + parseInt(user.acceptedFattCasesCount) + parseInt(user.acceptedRCCount) + parseInt(user.acceptedConsCount);
    user.requests = parseInt(user.createdcasescount) + parseInt(user.createdcrcount) + parseInt(user.createdtrcount) + parseInt(user.createdrccount) + parseInt(user.createdFattCount);
    user.anotherBarNumber = {
        barNumber: '',
        state: ''
    };
    user.doubleState = user.states.length === 2;
    user.states = Array.isArray(user.states) ? user.states.map((state) => {
        if (user.deleted) {
            state.status = 'Deleted';
        }
        if (state.rejected) {
            state.status = 'Rejected';
        }
        if (state.bar_number_blocked) {
            state.status = 'Licence Blocked';
        }
        return state;
    }) : [];
    return user;
};
exports.mutateUser = mutateUser;
